import { useEffect, useState } from "react"
import { Modal } from "flowbite-react"
import { useToastContext } from "../../../../common/components/ui/toast/toast.context"
import FormSuspendRepossession from "../forms/FormSuspendRepossession"
import Loading from "../../../../common/components/ui/loading/Loading"
import { suspendRepossession } from "../../../../common/services/repossession.api"

type Props = {
  vehicle: null | string
  onClose: () => void
}

export default function ModalSuspendRepossession(props: Props) {
  const [vehicle, setVehicle] = useState<string | null>(null)
  const { showToast } = useToastContext()
  const [formRequestErrors] = useState([])

  const notifySuccess = (text) => showToast({ text, type: 'success' })
  const notifyError = (text) => showToast({ text, type: 'error' })
  const handleCloseModal = () => { props.onClose() }

  useEffect(() => { props.vehicle !== vehicle && setVehicle(props.vehicle) }, [props.vehicle, vehicle])

  async function submitSuspendRepossession(suspendedNotes: string) {
    try {
      const response = await suspendRepossession(vehicle as string, suspendedNotes);
      const { ok } = response;

      if (ok) {
        setVehicle(null);
        notifySuccess(`Recolhimento do veículo suspenso com sucesso!`);
        handleCloseModal();
        return { ok };
      }

      if (!ok) {
        notifyError(`Erro ao tentar suspender o recolhimento do veículo`);
      }

      return { ok };
    } catch (err) {
      notifyError('Erro ao tentar salvar cliente, tente novamente');
      return {
        ok: false,
        data: suspendedNotes,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }],
      };
    }
  }

  return (
    <Modal
      size={'5xl'}
      className='relative'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black'>
        <div className="flex items-center justify-start gap-3 text-black">
          <span>
            {`Suspender Recolhimento - ${vehicle}`}
          </span>
        </div>
      </Modal.Header>
      <Modal.Body className='w-full relative border-gray flex flex-col text-black' style={{ minHeight: 'calc(50vh - 300px)', height: 'calc(100vh - 300px)' }}>
        {vehicle ? (
          <FormSuspendRepossession data={vehicle} onSubmit={submitSuspendRepossession} formRequestErrors={formRequestErrors} />
        ) : <Loading />}
      </Modal.Body>
    </Modal>
  );
}
